export default "__VITE_ASSET__Crxf7c$7__"